<div class="row">
  <div class="col-12">
    <div class="card">
      <div
        _ngcontent-rps-c192=""
        class="card-header spear-table-header-background d-flex justify-content-between"
      >
        <h6>Contact</h6>
      </div>
      <div class="card-body">
        <div _ngcontent-bmk-c200="" class="row">
          <div class="col-md-12">
            <div class="w-100">
              <div class="row">
                <div class="col-12 primary-tab">
                  <ul class="nav nav-tabs">
                    <ng-container *ngFor="let tab of tabs">
                      <li class="nav-item text-black-contrast">
                        <button
                          [ngClass]="{
                            'bg-white': activeTab === tab,
                            'text-uppercase': true
                          }"
                          (click)="activeTab = tab"
                          class="nav-link"
                        >
                          {{ tab }}
                        </button>
                      </li>
                    </ng-container>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoices-list bg-white" *ngIf="activeTab === 'Client Contacts'">
          <app-client-contact></app-client-contact>
        </div>
        <div class="invoices-list bg-white" *ngIf="activeTab === 'Program Contact'">
          <app-client-program-contact></app-client-program-contact>
        </div>
        <div class="invoices-list bg-white" *ngIf="['Lien Representative', 'Defense Attorneys', 'Applicant Attorneys', 'Other'].includes(activeTab)">
          <app-lien-representative [tabType]="activeTab"></app-lien-representative>
        </div>
        <div class="invoices-list bg-white" *ngIf="activeTab === 'Prospective Client'">
          <app-prospective-client></app-prospective-client>
        </div>
        <div class="invoices-list bg-white" *ngIf="activeTab === 'Employee'">
          <app-client-employee></app-client-employee>
        </div>
      </div>
    </div>
  </div>
</div>
